import { useNavigate } from 'react-router-dom';
import Header from './components/header';
import { useState } from 'react';
import Footer from './components/footer';



function RoVersion(props) {
  const [email, setEmail] = useState();
  const [userId, setUserId] = useState();
  const [message, setMessage] = useState();

  const sendRequest = (email, userId) => {
    if (!email || !userId) {
      setMessage('Email si userId este necesar pentru trimitere');
    } else {
      props.sendRequest(email, userId);
      setMessage('Cerere trimisa. Veti primi un email de confirmare ca am primit cererea si ca datele au fost sterse');
    }
  }

  return (
    <>
        <div className='section-spacer' />
        <div id='section-top' className='width-3-4 sp-bt-2'>
        Data Safety
        </div>

        <div id='section-top' className='width-3-4 sp-bt-2'>
        Procedura stergere date utilizator
        </div>


        <div className='horizontal-space-30' />

        <div className='title full-width sp-bt-2'>Date salvate</div>
        <div className='full-width'>
          <div>În timpul funcționării normale a aplicației, stocăm în bazele de date următoarele informatii, astfel încât să oferim funcționalitatea normala:</div>
          <div>Pentru proprietarul aplicației: nume de utilizator, e-mail</div>
          <div>Pentru pacienții înregistrați: nume, data nașterii, sex, informații despre starea lor medicală, rezultatele examinărilor medicale și sugestiile medicale oferite de medicul profesionist care utilizeaza aplicația</div>
        </div>

        <div className='horizontal-space-30' />

        <div className='title full-width sp-bt-2'>Pasi de urmat pentru stergerea datelor</div>
        <div className='full-width'>
          <div>1. Obțineți ID-ul de utilizator din aplicația instalată pe dispozitivul mobil</div>
          <div>2. Trimiteți cererea catre e-mailul mentionat in sectiunea "Detalii de contact" sau folosind formularul de mai jos</div>
          <div>3. În orice caz, vom confirma primirea cererii</div>
        </div>

        <div className='horizontal-space-30' />

        <form>
          <label>Username / Email</label>
          <input name="email" type='email' placeholder='email@gmail.com'
            value={email}
            onChange={e => { setEmail(e.target.value); setMessage('') }} />


          <div className='horizontal-space-10' />
          <label>User Id</label>
          <input name="specializare" type='text' placeholder='necesar'
            value={userId}
            onChange={e => {setUserId(e.target.value); setMessage('') }} />

          <div className='horizontal-space-30' />

          <div className='btn-body' onClick={() => {sendRequest(email, userId)}}>Trimiteți cererea de ștergere a datelor</div>

          <div className='horizontal-space-10' />

          {message && <label>{message}</label>}

        </form>

        <div className='horizontal-space-40' />

        <div className='title full-width sp-bt-2'>Detalii de contact</div>
        <div className='full-width'>
          <div>Dezvoltatorul poate fi contactat direct la</div>
          <div>Email: arsmedica.tech@gmail.com</div>
          <div>Telefon: +40 741 511 416</div>
        </div>
    </>
  )
}

function EnVersion(props) {
  const [email, setEmail] = useState();
  const [userId, setUserId] = useState();
  const [message, setMessage] = useState();

  const sendRequest = (email, userId) => {
    if (!email || !userId) {
      setMessage('Email si userId este necesar pentru trimitere');
    } else {
      props.sendRequest(email, userId);
      setMessage('Request sent. You will receive a confirmation email that we have received the request and that the user data has been deleted');
    }
  }

  return (
    <>
        <div className='section-spacer' />
        <div id='section-top' className='width-3-4 sp-bt-2'>
        Data Safety
        </div>

        <div id='section-top' className='width-3-4 sp-bt-2'>
        Delete User Data Procedure
        </div>

        <div className='horizontal-space-30' />

        <div className='title full-width sp-bt-2'>Stored Account Data</div>
        <div className='full-width'>
          <div>During normal operation of the app we store in our databases, follwing data so that we provided the expected functionality:</div>
          <div>For the owner of the app: User name, email</div>
          <div>For the registered patients: name, date of birth, sex, information about their medical state, results of medical examinations and suggested medication given by the professional medic who is operating the app</div>
        </div>

        <div className='horizontal-space-30' />

        <div className='title full-width sp-bt-2'>Delete user data steps</div>
        <div className='full-width'>
          <div>1. Obtain user id from the app installed on the mobile device</div>
          <div>2. Send the request to the email mentioned in the "Contact Details" section or by using the form bellow</div>
          <div>3. In any case we will confirm the receipt of the request</div>
        </div>

        <div className='horizontal-space-30' />

        <form>
          <label>Username / Email</label>
          <input name="email" type='email' placeholder='email@gmail.com'
            value={email}
            onChange={e => { setEmail(e.target.value); setMessage('') }} />


          <div className='horizontal-space-10' />
          <label>User Id</label>
          <input name="specializare" type='text' placeholder='required'
            value={userId}
            onChange={e => {setUserId(e.target.value); setMessage('') }} />

          <div className='horizontal-space-30' />

          <div className='btn-body' onClick={() => {sendRequest(email, userId)}}>Send Delete Data Request</div>

          <div className='horizontal-space-10' />

          {message && <label>{message}</label>}

        </form>

        <div className='horizontal-space-40' />


        <div className='title full-width sp-bt-2'>Contact details</div>
        <div className='full-width'>
          <div>Contact the developer for direct request at</div>
          <div>email: arsmedica.tech@gmail.com</div>
          <div>phone: +40 741 511 416</div>
        </div>
    </>
  )
}

function DeleteDataPage() {
  const [eng, setEng] = useState(true);
  const navigate = useNavigate();

  const goToParticipateForm = () => {
    navigate('/');
  }

  const sendRequest = (email, userId) => {
    fetch('https://09mclyfv7k.execute-api.eu-central-1.amazonaws.com/prod/data-safety', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        type: 'Delete Data Request',
        name: 'Contact Form',
        from: 'Art Medica',
        email: email,
        userId: userId
      })
    }).then((response) => response.json().then((responseData) => {
      console.log('Response received %o', responseData);
    }));
  }

  return (
    <div className='content'>
        <Header participate={() => goToParticipateForm()} />

        {eng && <div onClick={() => setEng(false)}>Limba: RO</div>}
        {!eng && <div onClick={()=> setEng(true)}>Language: EN</div>}


        {eng && <EnVersion sendRequest={sendRequest}/>}
        {!eng && <RoVersion sendRequest={sendRequest}/>}

        <div className='section-spacer' />
        <Footer />
        <div className='section-spacer' />
    </div>
  )
}

export default DeleteDataPage;